import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/Hero";
import Features from "../components/Features/Features";
import Influence from "../components/Influence/Influence";
import Gameplay from "../components/Gameplay/Gameplay";
import Showcase from "../components/Showcase/Showcase";
import SocialProof from "../components/SocialProof/SocialProof";
import Gallery from "../components/Gallery/Gallery";
import CTA from "../components/CTA/CTA";

export default function LandingPage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Influence />
        <Gameplay />
        <Showcase />
        <SocialProof />
        <Gallery />
        <CTA />
      </main>
    </>
  );
}
